const emailingValues = {
  instant: {
    instant: () => 'Instant',
    minutes: (notificationNumber) => `Each ${notificationNumber} min`,
    hour: () => `Each hour`,
  },
  daily: 'Daily Recap',
  weekly: 'Weekly',
  none: 'Never',
  global: 'Global',
};

export function getNotificationFrequencyValue({ enabled, notification, notificationFrequency, notificationNumber }) {
  if (!enabled) {
    return 'Off';
  }

  notification = notification?.toLowerCase() || 'none';
  const value = emailingValues[notification];
  if (typeof value === 'object') {
    const key = notificationFrequency?.toLowerCase() in value ? notificationFrequency?.toLowerCase() : 'instant';
    return value[key](notificationNumber);
  }
  return value;
}

/** Admin Emailing dropdown options (global user prefs). */
export const EMAILING_FREQUENCY_OPTIONS = [
  {
    value: 'instant',
    label: 'Instant',
    savedSearchTypeNotices: 'instant',
    consolidateNotificationSelect: 'instant',
    consolidateNotificationNumber: 5,
  },
  {
    value: '15',
    label: '15 Minutes',
    savedSearchTypeNotices: 'instant',
    consolidateNotificationSelect: 'minutes',
    consolidateNotificationNumber: 15,
  },
  {
    value: '30',
    label: '30 Minutes',
    savedSearchTypeNotices: 'instant',
    consolidateNotificationSelect: 'minutes',
    consolidateNotificationNumber: 30,
  },
  {
    value: '1',
    label: '1 hour',
    savedSearchTypeNotices: 'instant',
    consolidateNotificationSelect: 'hour',
    consolidateNotificationNumber: 1,
  },
  {
    value: 'daily',
    label: 'Daily Recap',
    savedSearchTypeNotices: 'daily',
    consolidateNotificationSelect: 'daily',
    consolidateNotificationNumber: 1,
  },
];

/**
 * Map user email preference fields to an EMAILING_FREQUENCY_OPTIONS value key.
 */
export function getEmailingFrequencyOptionValue(userDetail = {}) {
  const type = (userDetail.savedSearchTypeNotices || '').toLowerCase();
  const select = (userDetail.consolidateNotificationSelect || '').toLowerCase();
  const num = Number(userDetail.consolidateNotificationNumber);

  if (type === 'daily' || select === 'daily') return 'daily';
  if (select === 'instant') return 'instant';
  if (select === 'minutes' && num === 15) return '15';
  if (select === 'minutes' && num === 30) return '30';
  if (select === 'hour') return '1';
  if (type === 'instant') return 'instant';
  return 'daily';
}

export function getEmailingFrequencyOption(value) {
  return (
    EMAILING_FREQUENCY_OPTIONS.find(opt => opt.value === value) ||
    EMAILING_FREQUENCY_OPTIONS.find(opt => opt.value === 'daily')
  );
}
